/* AquaGrip CT - THE COOLER PAD STUDIO (6 Oct 2026). James: "cooler studio needs to be like the helm pad studio ... choose their cooler
   brand then cooler size it comes on the screen then they can choose a pattern like on helm pad studio add a logo or ruler"; "1 yes"
   (the helm studio's patterns and colours, 6mm only); "keep cooler prices the same and add 5 dollar up charge for the pattern"; "one page
   with all the coolers"; "ruler 12" and up".
   WHAT IT DRAWS IS WHAT THE SHOP CUTS: every lid's outline and every pattern's grooves are the cooler engine's own (the DeckStudio cooler
   engine, the same one Cut Queue runs on the order), read off its files when the page was built (ag-cooler-g-<lid>.json); the ruler is
   drawn where Cut Queue will cut it (the engine's length, centre and number layout; Cut Queue's own Serpentine D outlines).
   THE CART: the lid's own Shopify variant (its price as today) with the build on it - _AGDesign "cooler-1", which Cut Queue reads - and
   the add-ons as the helm studio's upcharge lines (Pattern $5, Fish Ruler $10, Logo $20), each tagged with the line's _config_uid so the
   cart customizer folds them into the line. The add-ons are added only after the pad line is in the cart; if they cannot be added, the
   pad line is taken back out - never a pad billed without its add-ons.
   BUILD PRODUCT of Apps/CoolerStudio-page-20261006 (make_theme_files.py) - edit the sources there. NO BACKSLASH IN THIS FILE. */
(function () {
  'use strict';
  var CFG = window.AG_COOLER_CFG || {};
  var NS = 'http://www.w3.org/2000/svg', XL = 'http://www.w3.org/1999/xlink';
  var IN = '″', X = '×', SEP = ' · ';
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) { if (a[k] !== null && a[k] !== undefined) e.setAttribute(k, a[k]); } return e; }
  function r2(v) { return Math.round(v * 100) / 100; }
  function inch(v) { return String(r2(v)) + IN; }
  function money(v) { return '$' + Number(v).toFixed(2); }
  function esc(s) { return String(s).replace(/[&]/g, '&amp;').replace(/[<]/g, '&lt;').replace(/[>]/g, '&gt;').replace(/["]/g, '&quot;'); }
  /* 16 Oct 2026 - THE NAMES SHOWN FOR TWO RTIC LIDS (James, "3- yes", to making the page say which 52 has wheels): the wheeled Ultra-Light
     is the lid sold as RTIC 52 Wheel. Display only - the cart line's Cooler property keeps the lid's own name (props() below uses L.n),
     which Cut Queue and BoxQueue read. The door (src/ag_cooler_door.liquid) shows the same two names, by the same SKUs. */
  var SHOWN = {rtic_52_wheel: 'RTIC 52 Ultra-Light Wheeled', rtic_52_ultra_light: 'RTIC 52 Ultra-Light (no wheels)', yeti_65_top: 'Yeti Tundra 65', yeti_15: 'Yeti Roadie 15', yeti_24: 'Yeti Roadie 24', yeti_32_roadie_wheeled: 'Yeti Roadie 32 Wheeled', yeti_48_roadie: 'Yeti Roadie 48', yeti_35: 'Yeti Tundra 35', yeti_45: 'Yeti Tundra 45', yeti_50: 'Yeti Tundra 50', yeti_75: 'Yeti Tundra 75', yeti_105: 'Yeti Tundra 105', yeti_110: 'Yeti Tundra 110', yeti_125: 'Yeti Tundra 125', yeti_160: 'Yeti Tundra 160', yeti_210: 'Yeti Tundra 210', yeti_250: 'Yeti Tundra 250', yeti_350: 'Yeti Tundra 350', yeti_420: 'Yeti Tundra 420'};   /* 18 Oct 2026: James, the Yeti 65 is the Tundra 65 */
  /* 18 Oct 2026 (James's OK list, 3): with no lid chosen - no deep link, no door, no saved design - the studio opens on the page's brand
     with "Pick your model" and no price; Add to Cart stays off until a model is picked (render / updateSide already handle no lid). */
  var START_BRAND = null;
  function shown(k, L) { return SHOWN[k] || L.n; }

  /* the helm studio's foam colours and its 6mm combos (aquagrip-design-studio.liquid FOAMC / COMBOS['6mm']). 8 Oct 2026: no 6mm
     Medium Gray / Dark Gray - James: "i dont normally stock that one 6mm" - taken out here and from the helm list. The fish ruler keeps it
     (James: "i have plenty of the rulers in stock so keep that"). */
  var FOAMC = {'Light Gray': '#bab9b6', 'Medium Gray': '#6d6966', 'Dark Gray': '#54514e', 'Black': '#17171b', 'White': '#f4f3ef', 'Navy': '#20375c',
    'Royal Blue': '#2d59b0', 'Ice Blue': '#b7d3de', 'Seafoam': '#8fc6b0', 'Teak': '#bc8b50', 'Brown': '#755f48', 'Khaki': '#867d6e', 'Cream': '#ece2c8',
    'Orange': '#f07d24', 'Red': '#c23b33', 'Snow Camo': '#dcdcd8', 'Army Camo': '#aa9a7d'};
  var COMBOS = [['Medium Gray', 'Black'], ['Medium Gray', 'Navy'], ['Medium Gray', 'Royal Blue'], ['Medium Gray', 'Seafoam'],
    ['Medium Gray', 'Ice Blue'], ['Medium Gray', 'Light Gray'], ['Medium Gray', 'Teak'], ['Dark Gray', 'Royal Blue'], ['Light Gray', 'Black'],
    ['Light Gray', 'Medium Gray'], ['Light Gray', 'Seafoam'], ['Light Gray', 'White'], ['Light Gray', 'Ice Blue'], ['Snow Camo', 'Dark Gray'],
    ['Army Camo', 'Black'], ['Teak', 'Black'], ['Teak', 'Cream'], ['Teak', 'Light Gray'], ['Teak', 'Medium Gray'], ['Brown', 'Black'], ['Khaki', 'Black']];
  /* the helm studio's patterns (PATTERNS); free ones as the helm studio's patternPremium(); the five that turn as helm_order.ROT_OK */
  var PATTERNS = [{id: 'plain', label: 'Plain'}, {id: 'perimeter', label: 'Perimeter Line'}, {id: 'teak', label: 'Teak Lines'}, {id: 'diamond', label: 'Diamonds'},
    {id: 'doublediamond', label: 'Double Diamond'}, {id: 'hex', label: 'Hexagon'}, {id: 'longhex', label: 'Long Hexagon'}, {id: 'fishscale4', label: 'Fish Scales 4' + IN},
    {id: 'fishscale', label: 'Fish Scales 6.6' + IN}, {id: 'fishscale8', label: 'Fish Scales 8' + IN}, {id: 'topo', label: 'Topographic'}];
  var FREE = {plain: 1, perimeter: 1, teak: 1};
  var ROT_OK = {hex: 1, longhex: 1, fishscale4: 1, fishscale: 1, fishscale8: 1};
  /* the add-on lines: the SAME variants the cooler pages and the helm studio bill (the cart customizer hides and folds exactly these) */
  var UP = {pattern: {id: 45854221369404, price: 5}, ruler: {id: 45454519763004, price: 10}, logo: {id: 45454519730236, price: 20}};
  /* WHERE CUT QUEUE CUTS THE RULER (lib/draw.cjs coolerRulerGeom): the comb's bar on the border line, its ticks, the numbers' baseline,
     in inches above the lid's lowest point */
  var RU = {inset: 1.186, major: 1.0, minor: 0.5, tick: 0.128, bar0: 1.185, bar1: 1.315, gap: 0.6562, cap: 1.0, every: 4};
  var SC = 10, ML = 110, MT = 80, MR = 30, MB = 30;
  var STORE = 'agCoolerDesign_v1';
  var DIG = CFG.digits || null;
  var FOAMTEX = window.AG_FOAM_TEX || {};
  var DEF = {key: null, top: 'Light Gray', bottom: 'Black', pat: 'perimeter', rot: 0, teakV: false, ruler: false, logoOn: false, logo: null};
  var S = JSON.parse(JSON.stringify(DEF));
  var LIDS = null, GEOM = {}, WAIT = {}, logoFile = null, logoImg = null, busy = false, opened = false, drag = null;

  function lid() { return (LIDS && S.key && LIDS.lids[S.key]) || null; }
  function geom() { return (S.key && GEOM[S.key]) || null; }
  function rulerFits() { var L = lid(); return !!(L && L.ru && L.ru.n >= 12); }
  function premium() { return !FREE[S.pat]; }
  function vkey(pat) {
    var p = pat || S.pat, k = p;
    if (p === 'teak' && S.teakV && !pat) k += '|v';
    if (ROT_OK[p] && S.rot === 90 && !pat) k += '|90';
    if (!pat && S.ruler && rulerFits()) k += '|r';
    return k;
  }
  function grooveCol() { return FOAMC[S.bottom] || '#17171b'; }
  function topCol() { return FOAMC[S.top] || '#bab9b6'; }
  function price() {
    var L = lid(); if (!L || L.p === null || L.p === undefined) return null;
    var p = Number(L.p);
    if (premium()) p += UP.pattern.price;
    if (S.ruler && rulerFits()) p += UP.ruler.price;
    if (S.logoOn) p += UP.logo.price;
    return p;
  }
  function patLabel(id) { for (var i = 0; i < PATTERNS.length; i++) if (PATTERNS[i].id === id) return PATTERNS[i].label; return id; }
  function patText() {
    var t = patLabel(S.pat);
    if (S.pat === 'teak') t += SEP + (S.teakV ? 'vertical' : 'horizontal');
    if (ROT_OK[S.pat] && S.rot === 90) t += SEP + 'rotated 90°';
    return t;
  }

  /* ---------- saved design (this browser only; a convenience) ---------- */
  function save() { if (!opened) return; try { localStorage.setItem(STORE, JSON.stringify(S)); } catch (e) {} }
  function restore() {
    try { var d = JSON.parse(localStorage.getItem(STORE) || 'null'); if (d && typeof d === 'object') { for (var k in DEF) if (d.hasOwnProperty(k)) S[k] = d[k]; } } catch (e) {}
    var ok = COMBOS.some(function (c) { return c[0] === S.top && c[1] === S.bottom; });
    if (!ok) { S.top = DEF.top; S.bottom = DEF.bottom; }
    if (!PATTERNS.some(function (p) { return p.id === S.pat; })) S.pat = DEF.pat;
    if (S.rot !== 90) S.rot = 0;
  }

  /* ---------- the lid's geometry, one file per lid, loaded when it is picked ---------- */
  function loadGeom(key, cb) {
    if (GEOM[key]) { cb(GEOM[key]); return; }
    var url = CFG.geom && CFG.geom[key];
    if (!url) { cb(null); return; }
    if (WAIT[key]) { WAIT[key].push(cb); return; }
    WAIT[key] = [cb];
    fetch(url, {credentials: 'same-origin'}).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) { GEOM[key] = j; var w = WAIT[key]; delete WAIT[key]; w.forEach(function (f) { f(j); }); })
      .catch(function (e) { if (window.console) console.error('[AG cooler] geometry for ' + key + ':', e); var w = WAIT[key]; delete WAIT[key]; w.forEach(function (f) { f(null); }); });
  }

  /* ---------- the ruler, as Cut Queue cuts it: page frame, 0.01 in units, y down ---------- */
  function rulerGroup(H, fill) {
    var L = lid(), f = L && L.ru;
    if (!f) return null;
    var n = f.n, hw = RU.tick / 2, x0 = f.cx - n / 2;
    function top(i) { return RU.inset + (i % RU.every === 0 ? RU.major : RU.minor); }
    var pts = [[x0 - hw, RU.bar0], [x0 + n + hw, RU.bar0]];
    for (var i = n; i >= 0; i--) {
      var xi = x0 + i, t = top(i);
      if (i !== n) pts.push([xi + hw, RU.bar1]);
      pts.push([xi + hw, t], [xi - hw, t]);
      if (i !== 0) pts.push([xi - hw, RU.bar1]);
    }
    var g = el('g', {fill: fill, 'data-ruler': '1', 'pointer-events': 'none'});
    g.appendChild(el('path', {d: 'M' + pts.map(function (p) { return (p[0] * 100).toFixed(1) + ' ' + ((H - p[1]) * 100).toFixed(1); }).join('L') + 'Z'}));
    if (DIG && f.nums) {
      var scale = RU.cap / DIG.cap, yNum = RU.inset + RU.major + RU.gap;
      f.nums.forEach(function (nm) {
        var pen = Number(nm[1]);
        String(nm[0]).split('').forEach(function (ch) {
          var gl = DIG.digits[ch]; if (!gl) return;
          g.appendChild(el('path', {d: gl.d, 'fill-rule': 'evenodd',
            transform: 'translate(' + (pen * 100).toFixed(2) + ' ' + ((H - yNum) * 100).toFixed(2) + ') scale(' + (0.1 * scale) + ' ' + (-0.1 * scale) + ')'}));
          pen += gl.adv * scale;
        });
      });
    }
    return g;
  }

  /* ---------- the drawing ---------- */
  function texDefs(svg, id, tile) {
    var t = FOAMTEX[S.top];
    if (!t) return null;
    var d = el('defs', {});
    var p = el('pattern', {id: id, patternUnits: 'userSpaceOnUse', x: 0, y: 0, width: tile[0], height: tile[1]});
    var im = el('image', {width: tile[0], height: tile[1], preserveAspectRatio: 'none'});
    im.setAttribute('href', t); im.setAttributeNS(XL, 'xlink:href', t);
    p.appendChild(im); d.appendChild(p); svg.appendChild(d);
    return 'url(#' + id + ')';
  }
  function render() {
    var svg = q('#agsSvg'); if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var L = lid(), G = geom();
    if (!L || !G) {
      svg.setAttribute('viewBox', '0 0 600 300');
      var t = el('text', {x: 300, y: 150, 'text-anchor': 'middle', fill: '#173152', 'font-family': 'Rubik,system-ui,sans-serif', 'font-size': '16'});
      t.textContent = L ? 'Loading your lid' + String.fromCharCode(8230) : 'Pick your cooler to see it here';
      svg.appendChild(t); updateSide(); return;
    }
    var W = G.W, H = G.H, pw = W * SC, ph = H * SC;
    svg.setAttribute('viewBox', '0 0 ' + (ML + pw + MR) + ' ' + (MT + ph + MB));
    var fillTop = texDefs(svg, 'agcTexTop', [500, 1000]) || topCol();
    var gl = el('g', {transform: 'translate(' + ML + ' ' + MT + ') scale(' + (SC / 100) + ')'});
    gl.appendChild(el('path', {d: G.cut, 'fill-rule': 'evenodd', fill: fillTop, stroke: grooveCol(), 'stroke-width': String(600 / SC), 'stroke-linejoin': 'round'}));
    var gd = G.g[vkey()];
    if (gd) gl.appendChild(el('path', {d: gd, 'fill-rule': 'evenodd', fill: grooveCol()}));
    if (S.ruler && rulerFits()) { var rg = rulerGroup(H, grooveCol()); if (rg) gl.appendChild(rg); }
    svg.appendChild(gl);
    /* the size, as the helm studio shows it */
    var dl = el('g', {fill: '#173152', 'font-family': 'Rubik,system-ui,sans-serif', 'font-size': '13', 'font-weight': '500'});
    dl.appendChild(el('line', {x1: ML, y1: MT - 34, x2: ML + pw, y2: MT - 34, stroke: '#173152', 'stroke-width': '1'}));
    dl.appendChild(el('line', {x1: ML, y1: MT - 40, x2: ML, y2: MT - 28, stroke: '#173152', 'stroke-width': '1'}));
    dl.appendChild(el('line', {x1: ML + pw, y1: MT - 40, x2: ML + pw, y2: MT - 28, stroke: '#173152', 'stroke-width': '1'}));
    var t1 = el('text', {x: ML + pw / 2, y: MT - 44, 'text-anchor': 'middle'}); t1.textContent = 'Width ' + inch(W) + SEP + '6mm'; dl.appendChild(t1);
    dl.appendChild(el('line', {x1: ML - 34, y1: MT, x2: ML - 34, y2: MT + ph, stroke: '#173152', 'stroke-width': '1'}));
    dl.appendChild(el('line', {x1: ML - 40, y1: MT, x2: ML - 28, y2: MT, stroke: '#173152', 'stroke-width': '1'}));
    dl.appendChild(el('line', {x1: ML - 40, y1: MT + ph, x2: ML - 28, y2: MT + ph, stroke: '#173152', 'stroke-width': '1'}));
    var t2 = el('text', {x: ML - 48, y: MT + ph / 2, 'text-anchor': 'middle', transform: 'rotate(-90 ' + (ML - 48) + ' ' + (MT + ph / 2) + ')'}); t2.textContent = 'Height ' + inch(H); dl.appendChild(t2);
    svg.appendChild(dl);
    if (S.logoOn && S.logo) svg.appendChild(logoGroup());
    var wmU = 'https://cdn.shopify.com/s/files/1/0688/8577/4396/files/ag_tuna_logo.svg?v=1762790630';
    var wmW = Math.min(50, Math.max(30, (ML + pw + MR) * 0.13)), wmH = wmW * 310 / 828;
    var wm = el('image', {x: ML + pw + MR - wmW - 1, y: MT + ph + MB - wmH - 0.5, width: wmW, height: wmH, opacity: '0.30', 'pointer-events': 'none', 'aria-hidden': 'true', 'data-ag-wm': '1', style: 'filter:brightness(0)'});
    wm.setAttribute('href', wmU); wm.setAttributeNS(XL, 'xlink:href', wmU); svg.appendChild(wm);
    updateSide();
  }
  function logoGroup() {
    var Lg = S.logo, lx = ML + (Lg.x - Lg.w / 2) * SC, ly = MT + (Lg.y - Lg.h / 2) * SC, lw = Lg.w * SC, lh = Lg.h * SC;
    var g = el('g', {'data-logo': '1', cursor: 'move'});
    if (logoImg) {
      var im = el('image', {x: lx, y: ly, width: lw, height: lh, preserveAspectRatio: 'xMidYMid meet'});
      im.setAttribute('href', logoImg); im.setAttributeNS(XL, 'xlink:href', logoImg); g.appendChild(im);
      g.appendChild(el('rect', {x: lx, y: ly, width: lw, height: lh, fill: 'none', stroke: '#c9a227', 'stroke-width': '2', 'stroke-dasharray': '8 6'}));
    } else {
      g.appendChild(el('rect', {x: lx, y: ly, width: lw, height: lh, fill: 'rgba(201,162,39,.12)', stroke: '#c9a227', 'stroke-width': '3', 'stroke-dasharray': '10 6'}));
      var t = el('text', {x: lx + lw / 2, y: ly + lh / 2 + 4, 'text-anchor': 'middle', fill: '#8a6d1a', 'font-family': 'Rubik,system-ui,sans-serif', 'font-size': '10', 'font-weight': '500'});
      t.textContent = 'LOGO'; g.appendChild(t);
    }
    return g;
  }

  /* ---------- the controls ---------- */
  function clampLogo() {
    var G = geom(); if (!S.logo || !G) return;
    var m = 1.315, Lg = S.logo;
    Lg.w = Math.max(1, Math.min(Number(Lg.w) || 6, G.W - 2 * m)); Lg.h = Math.max(1, Math.min(Number(Lg.h) || 3, G.H - 2 * m));
    Lg.w = Math.round(Lg.w * 4) / 4; Lg.h = Math.round(Lg.h * 4) / 4;
    var lo = m + Lg.w / 2, hi = G.W - m - Lg.w / 2, x = Math.min(Math.max(Number(Lg.x), lo), hi);
    var top = m + Lg.h / 2, bot = G.H - (S.ruler && rulerFits() ? 4.05 : m) - Lg.h / 2, y = Math.min(Math.max(Number(Lg.y), top), Math.max(top, bot));
    Lg.x = Math.round(x * 8) / 8; Lg.y = Math.round(y * 8) / 8;
  }
  function defaultLogo() { var G = geom(); if (!G) return {w: 6, h: 3, x: 6, y: 4}; return {w: 6, h: 3, x: G.W / 2, y: G.H / 2 - (rulerFits() ? 1.4 : 0)}; }
  function buildBrands() {
    var bs = q('#agcBrand'), ms = q('#agcModel'); if (!bs || !ms || !LIDS) return;
    bs.innerHTML = LIDS.brands.map(function (b) { return '<option value="' + esc(b[0]) + '">' + esc(b[0]) + '</option>'; }).join('');
    var L = lid(); if (L) bs.value = L.b; else if (START_BRAND) bs.value = START_BRAND;
    buildModels();
  }
  function buildModels() {
    var bs = q('#agcBrand'), ms = q('#agcModel'); if (!bs || !ms || !LIDS) return;
    var b = null; LIDS.brands.forEach(function (x) { if (x[0] === bs.value) b = x; });
    if (!b) return;
    /* 18 Oct 2026 (James, report 274 call 6: yes): each brand's models listed by the name shown, numbers compared as numbers - the
       Roadies sit together, the Tundras sit together. The lid file's own order is left as it is. */
    var keys = b[1].slice().sort(function (p, r) { return String(shown(p, LIDS.lids[p])).localeCompare(String(shown(r, LIDS.lids[r])), undefined, {numeric: true, sensitivity: 'base'}); });
    ms.innerHTML = keys.map(function (k) {
      var L = LIDS.lids[k];
      return '<option value="' + esc(k) + '">' + esc(shown(k, L) + ' (' + r2(L.W) + IN + ' ' + X + ' ' + r2(L.H) + IN + ')' + (L.vid ? '' : ' - call to order')) + '</option>';
    }).join('');
    if (S.key && b[1].indexOf(S.key) > -1) ms.value = S.key;
    else { S.key = null; ms.insertAdjacentHTML('afterbegin', '<option value="" selected>Pick your model' + String.fromCharCode(8230) + '</option>'); ms.value = ''; render(); }
  }
  function pickLid(key) {
    if (!LIDS || !LIDS.lids[key]) return;
    S.key = key;
    var ms = q('#agcModel'); if (ms && ms.value !== key) ms.value = key;
    if (!rulerFits()) S.ruler = false;
    render();
    loadGeom(key, function () { if (S.key !== key) return; if (S.logoOn) { if (!S.logo) S.logo = defaultLogo(); clampLogo(); } buildTiles(); render(); save(); });
  }
  function buildColors() {
    var host = q('#agsColors'); if (!host) return;
    host.innerHTML = '';
    COMBOS.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ags-cswatch' + (c[0] === S.top && c[1] === S.bottom ? ' on' : '');
      b.title = c[0] + ' / ' + c[1];
      b.innerHTML = "<span class='ags-cchip'><span style='display:block;height:22px;background:" + FOAMC[c[0]] + "' class='" + (FOAMTEX[c[0]] ? ('agtx-' + c[0].replace(/ /g, '-')) : '') + "'></span><span style='display:block;height:12px;background:" + FOAMC[c[1]] + "'></span></span><span class='cl'>" + esc(c[0]) + ' / ' + esc(c[1]) + '</span>';
      b.addEventListener('click', function () { S.top = c[0]; S.bottom = c[1]; buildColors(); buildTiles(); render(); save(); });
      host.appendChild(b);
    });
  }
  function injectTexCSS() {
    try { var s = ''; for (var k in FOAMTEX) s += '.agtx-' + k.replace(/ /g, '-') + '{background-image:url(' + FOAMTEX[k] + ');background-size:100% auto;}';
      if (s) { var st = document.createElement('style'); st.textContent = s; document.head.appendChild(st); } } catch (e) {}
  }
  function buildTiles() {
    var host = q('#agsPats'); if (!host) return;
    var G = geom();
    host.innerHTML = '';
    PATTERNS.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ags-ptile' + (p.id === S.pat ? ' on' : '');
      var sv = el('svg', {viewBox: G ? ('-30 -30 ' + (G.W * 100 + 60) + ' ' + (G.H * 100 + 60)) : '0 0 100 60', xmlns: NS});
      if (G) {
        sv.appendChild(el('path', {d: G.cut, 'fill-rule': 'evenodd', fill: topCol(), stroke: grooveCol(), 'stroke-width': '40'}));
        var gd = G.g[p.id];
        if (gd) sv.appendChild(el('path', {d: gd, 'fill-rule': 'evenodd', fill: grooveCol()}));
      }
      b.appendChild(sv);
      var lb = document.createElement('span'); lb.className = 'pl'; lb.textContent = p.label; b.appendChild(lb);
      var pu = document.createElement('span'); pu.className = 'pu'; pu.textContent = FREE[p.id] ? 'included' : '+$' + UP.pattern.price; b.appendChild(pu);
      b.addEventListener('click', function () { S.pat = p.id; if (!ROT_OK[p.id]) S.rot = 0; buildTiles(); render(); save(); });
      host.appendChild(b);
    });
  }
  function updateSide() {
    var L = lid(), G = geom(), P = price();
    var sc = q('#agcSizeCur'); if (sc) sc.textContent = L ? (r2(L.W) + IN + ' ' + X + ' ' + r2(L.H) + IN) : '';
    var cc = q('#agsColCur'); if (cc) cc.textContent = S.top + ' / ' + S.bottom;
    var pc = q('#agcPatCur'); if (pc) pc.textContent = patText();
    var tr = q('#agcTeakRow'); if (tr) tr.style.display = S.pat === 'teak' ? '' : 'none';
    var rr = q('#agcRotRow'); if (rr) rr.style.display = ROT_OK[S.pat] ? '' : 'none';
    var th = q('#agcTeakH'), tv = q('#agcTeakV'), r0 = q('#agcRot0'), r9 = q('#agcRot90');
    if (th) th.classList.toggle('on', !S.teakV); if (tv) tv.classList.toggle('on', !!S.teakV);
    if (r0) r0.classList.toggle('on', S.rot !== 90); if (r9) r9.classList.toggle('on', S.rot === 90);
    var lsw = q('#agsLogoSw'); if (lsw) lsw.classList.toggle('on', !!S.logoOn);
    var lf = q('#agsLogoFlds'), lu = q('#agsLogoUpWrap'); if (lf) lf.style.display = S.logoOn ? '' : 'none'; if (lu) lu.style.display = S.logoOn ? '' : 'none';
    var lcw = q('#agsLogoCenterWrap'); if (lcw) lcw.style.display = S.logoOn ? '' : 'none';
    var lw = q('#agsLw'), lh = q('#agsLh'); if (S.logo) { if (lw && document.activeElement !== lw) lw.value = S.logo.w; if (lh && document.activeElement !== lh) lh.value = S.logo.h; }
    var lp = q('#agcLogoPrice'); if (lp) lp.textContent = '+$' + UP.logo.price;
    var fits = rulerFits(), rsw = q('#agsRulSw'), rl = q('#agcRulerLen'), rn = q('#agcRulerNo');
    if (rsw) { rsw.classList.toggle('on', !!(S.ruler && fits)); rsw.disabled = !fits; rsw.style.opacity = fits ? '' : '.4'; }
    if (rl) rl.textContent = fits ? ('0' + String.fromCharCode(8211) + L.ru.n + IN) : '';
    if (rn) { rn.style.display = (L && !fits) ? '' : 'none'; rn.textContent = L && !fits ? 'This lid has no room for a ruler of 12' + IN + ' or more along its bottom edge.' : ''; }
    var pr = q('#agsPrice'); if (pr) pr.textContent = P === null ? String.fromCharCode(8212) : money(P);
    var sp = q('#agsSpec');
    if (sp) {
      var bits = L ? ['<b>' + esc(shown(S.key, L)) + '</b>', esc(r2(L.W) + IN + ' ' + X + ' ' + r2(L.H) + IN), '6mm', esc(S.top + ' / ' + S.bottom), esc(patText())] : ['Pick your cooler'];
      if (L && S.ruler && fits) bits.push('Ruler 0' + String.fromCharCode(8211) + L.ru.n + IN);
      if (L && S.logoOn) bits.push('Logo');
      sp.innerHTML = bits.map(function (b) { return "<span class='p'>" + b + '</span>'; }).join("<span class='sep'>/</span><wbr>");   /* <wbr>: a place to wrap on a phone */
    }
    var bd = q('#agsBuild');
    if (bd && L) {
      var rows = [['Cooler pad', shown(S.key, L), L.p === null || L.p === undefined ? 'call' : money(L.p)]];
      rows.push(['Pattern', patLabel(S.pat), premium() ? money(UP.pattern.price) : 'included']);
      if (S.ruler && fits) rows.push(['Fish ruler', '0' + String.fromCharCode(8211) + L.ru.n + IN, money(UP.ruler.price)]);
      if (S.logoOn) rows.push(['Logo', S.logo ? (S.logo.w + IN + ' ' + X + ' ' + S.logo.h + IN + ' box') : '', money(UP.logo.price)]);
      bd.innerHTML = '<h4>Your build</h4><div class="bsub">' + esc(L.b) + SEP + '6mm' + SEP + esc(S.top + ' / ' + S.bottom) + '</div>' +
        rows.map(function (r) { return '<div class="ags-brow"><span class="k">' + esc(r[0]) + '<small>' + esc(r[1]) + '</small></span><span class="v">' + esc(r[2]) + '</span></div>'; }).join('') +
        '<div class="ags-btot"><span>Total</span><span>' + (P === null ? 'call us' : money(P)) + '</span></div>';
    }
    var atc = q('#agsAtc'), note = q('#agcNote');
    var canBuy = !!(L && L.vid && G);
    if (atc && !busy) { atc.disabled = !canBuy; atc.textContent = 'Add to Cart'; }
    if (note) {
      if (L && !L.vid) note.innerHTML = 'This cooler isn' + String.fromCharCode(8217) + 't in the online studio yet' + (L.url ? ' &#8212; order it on <a href="' + esc(L.url) + '">its own page</a>, or' : ' &#8212;') + ' call 203-580-8080 and we' + String.fromCharCode(8217) + 'll make it for you.';
      else if (L && !G) note.textContent = 'Loading your lid' + String.fromCharCode(8230);
      else note.textContent = '';
    }
  }

  /* ---------- the cart ---------- */
  function design() {
    var L = lid(), G = geom();
    return {v: 'cooler-1', shape: 'cooler', model: S.key, outline_sha: L.sha, W: G.W, H: G.H, thk: '6mm', colors: {top: S.top, bottom: S.bottom},
      pattern: {id: S.pat, rot: ROT_OK[S.pat] ? S.rot : 0, sx: 0, sy: 0}, pockets: [], cuts: [],
      logo: S.logoOn && S.logo ? {w: S.logo.w, h: S.logo.h, x: S.logo.x, y: S.logo.y} : null,
      ruler: S.ruler && rulerFits() ? {max: L.ru.n} : null};
  }
  function props(uid) {
    var L = lid(), G = geom(), P = {};
    P['Cooler'] = L.n;
    P['Size'] = r2(G.W) + '" ' + X + ' ' + r2(G.H) + '"';
    P['Colors'] = S.top + ' / ' + S.bottom;
    P['Pattern'] = patText();
    if (S.pat === 'teak') P['_Pattern'] = S.teakV ? 'Vertical' : 'Horizontal';
    if (S.ruler && rulerFits()) P['Ruler Engraving'] = 'Yes - 0' + String.fromCharCode(8211) + L.ru.n + IN + ' (+' + money(UP.ruler.price) + ')';
    if (S.logoOn) {
      P['Logo Engraving'] = 'Yes (+' + money(UP.logo.price) + ')';
      if (S.logo) P['Logo Placement'] = S.logo.w + IN + ' ' + X + ' ' + S.logo.h + IN + ' box' + SEP + 'center X ' + S.logo.x + IN + ' from left, Y ' + S.logo.y + IN + ' from top';
      if (!logoFile) P['Logo artwork'] = 'Not uploaded - emailing it, or already on file';
    }
    if (premium()) P['Pattern Upgrade'] = 'Yes (+' + money(UP.pattern.price) + ')';
    /* Bespoke rates the box from these, exactly as the cooler pages write them: a pad over 41 in ships rolled, rated as 45 x 30 */
    var w = Math.round(G.W), h = Math.round(G.H);
    if (Math.max(w, h) > 41) { w = 45; h = 30; }
    P['_Custom Dimension-Length (Left To Right)'] = w + ' Inches';
    P['_Custom Dimension-Height (Top To Bottom)'] = h + ' Inches';
    P['_config_uid'] = uid;
    P['_AGDesign'] = JSON.stringify(design());
    return P;
  }
  function snapshot() {
    return new Promise(function (resolve) {
      try {
        var svg = q('#agsSvg'); if (!svg) { resolve(null); return; }
        var c = svg.cloneNode(true);
        qa('image', c).forEach(function (im) { var h = im.getAttribute('href') || im.getAttributeNS(XL, 'href') || ''; if (h.indexOf('data:') !== 0) im.parentNode.removeChild(im); });
        var vb = (svg.getAttribute('viewBox') || '0 0 600 300').split(' ').map(Number), Wp = 1200, Hp = Math.round(1200 * vb[3] / vb[2]);
        c.setAttribute('width', Wp); c.setAttribute('height', Hp); c.setAttribute('xmlns', NS); c.setAttribute('xmlns:xlink', XL);
        var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(c));
        var img = new Image();
        img.onload = function () {
          try {
            var cv = document.createElement('canvas'); cv.width = Wp; cv.height = Hp;
            var cx = cv.getContext('2d'); cx.fillStyle = '#ffffff'; cx.fillRect(0, 0, Wp, Hp); cx.drawImage(img, 0, 0, Wp, Hp);
            var du = cv.toDataURL('image/png'), bin = atob(du.split(',')[1]), u8 = new Uint8Array(bin.length);
            for (var i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
            resolve(new File([u8], 'cooler-design-' + S.key + '.png', {type: 'image/png'}));
          } catch (e) { resolve(null); }
        };
        img.onerror = function () { resolve(null); };
        img.src = url;
      } catch (e) { resolve(null); }
    });
  }
  function hint(msg, bad) { var h = q('#agcHint'); if (h) { h.textContent = msg; h.style.color = bad ? '#8a2a2a' : ''; } }
  function addToCart() {
    var L = lid(), G = geom();
    if (busy || !L || !L.vid || !G) return;
    busy = true;
    var atc = q('#agsAtc'); if (atc) { atc.disabled = true; atc.textContent = 'Adding' + String.fromCharCode(8230); }
    var uid = 'cfg-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    var P = props(uid);
    var ups = [];
    if (premium()) ups.push(UP.pattern.id);
    if (S.ruler && rulerFits()) ups.push(UP.ruler.id);
    if (S.logoOn) ups.push(UP.logo.id);
    function fail(msg) { busy = false; if (atc) { atc.disabled = false; atc.textContent = 'Add to Cart'; } hint(msg, true); }
    snapshot().then(function (snap) {
      var fd = new FormData();
      fd.append('id', String(L.vid)); fd.append('quantity', '1');
      for (var k in P) fd.append('properties[' + k + ']', P[k]);
      if (snap) fd.append('properties[Design Snapshot]', snap, snap.name);
      if (S.logoOn && logoFile) fd.append('properties[Logo File]', logoFile, logoFile.name);
      return fetch('/cart/add.js', {method: 'POST', body: fd, credentials: 'same-origin', headers: {'Accept': 'application/json'}})
        .then(function (r) { return r.json().then(function (j) { return {ok: r.ok, j: j}; }, function () { return {ok: r.ok, j: null}; }); });
    }).then(function (res) {
      if (!res.ok) { fail((res.j && (res.j.description || res.j.message)) || 'Could not add to the cart - please try again or call 203-580-8080.'); return null; }
      var key = res.j && res.j.key;
      if (!ups.length) return {key: key};
      var items = ups.map(function (id) { return {id: id, quantity: 1, properties: {_config_uid: uid}}; });
      function addUps(tries) {
        return fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: items})})
          .then(function (r) { if (r.ok) return {key: key}; throw new Error('HTTP ' + r.status); })
          .catch(function (e) {
            if (tries < 2) return new Promise(function (ok) { setTimeout(ok, 700); }).then(function () { return addUps(tries + 1); });
            /* never a pad billed without its add-ons: take the pad line back out */
            return fetch('/cart/change.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: key, quantity: 0})})
              .then(function () { return {failed: true}; }, function () { return {failed: true}; });
          });
      }
      return addUps(0);
    }).then(function (done) {
      if (!done) return;
      if (done.failed) { fail('The add-ons could not be added, so nothing was added - please try again or call 203-580-8080.'); return; }
      var ptid = null; try { ptid = new URLSearchParams(location.search).get('preview_theme_id'); } catch (e) {}
      location.href = '/cart' + (ptid ? '?preview_theme_id=' + encodeURIComponent(ptid) : '');
    }).catch(function (e) { if (window.console) console.error('[AG cooler] cart:', e); fail('Could not add to the cart - please try again or call 203-580-8080.'); });
  }

  /* ---------- the preview's logo drag ---------- */
  function svgPt(ev) { var svg = q('#agsSvg'), pt = svg.createSVGPoint(); pt.x = ev.clientX; pt.y = ev.clientY; var m = svg.getScreenCTM(); if (!m) return null; var p = pt.matrixTransform(m.inverse()); return {x: (p.x - ML) / SC, y: (p.y - MT) / SC}; }
  function onDown(ev) {
    var t = ev.target.closest ? ev.target.closest('[data-logo]') : null; if (!t || !S.logo) return;
    var p = svgPt(ev); if (!p) return;
    ev.preventDefault(); drag = {dx: p.x - S.logo.x, dy: p.y - S.logo.y, g: t};
    try { q('#agsSvg').setPointerCapture(ev.pointerId); } catch (e) {}
  }
  function onMove(ev) {
    if (!drag) return; var p = svgPt(ev); if (!p) return; ev.preventDefault();
    S.logo.x = p.x - drag.dx; S.logo.y = p.y - drag.dy; clampLogo();
    var nu = logoGroup(); drag.g.parentNode.replaceChild(nu, drag.g); drag.g = nu;
  }
  function onUp() { if (!drag) return; drag = null; render(); save(); }

  /* ---------- open, close, wire ---------- */
  /* the overlay lives on <body>, as the helm studio's does: inside the page section it sits in #MainContent's stacking context
     (position relative, z-index 1) and the theme's sticky header (z-index 3) covers its top bar, price and Close */
  function toBody() { var ov = q('#agsOverlay'); if (ov && ov.parentNode !== document.body) document.body.appendChild(ov); return ov; }
  function open() {
    var ov = toBody(); if (!ov) return;
    ov.classList.add('on'); ov.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; opened = true;
    fetch('/cart.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}}).then(function (r) { return r.json(); })
      .then(function (c) { var n = q('#agsCartN'); if (n) n.textContent = c && c.item_count ? '(' + c.item_count + ')' : ''; }).catch(function () {});
    render();
  }
  function close() { var ov = q('#agsOverlay'); if (!ov) return; ov.classList.remove('on'); ov.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }
  function wire() {
    qa('[data-ag-cooler-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    document.addEventListener('click', function (e) {   /* 8 Oct: a brand page's door - opens the studio on its model */
      var t = e.target && e.target.closest ? e.target.closest('[data-ag-cooler-open-on]') : null;
      if (!t) return;
      e.preventDefault();
      openOn(t.getAttribute('data-ag-cooler-open-on'));
    });
    var c = q('#agsClose'); if (c) c.addEventListener('click', close);
    var bs = q('#agcBrand'); if (bs) bs.addEventListener('change', function () { buildModels(); });
    var ms = q('#agcModel'); if (ms) ms.addEventListener('change', function () { if (!ms.value) { S.key = null; render(); return; } pickLid(ms.value); });
    var th = q('#agcTeakH'), tv = q('#agcTeakV'), r0 = q('#agcRot0'), r9 = q('#agcRot90');
    if (th) th.addEventListener('click', function () { S.teakV = false; render(); save(); });
    if (tv) tv.addEventListener('click', function () { S.teakV = true; render(); save(); });
    if (r0) r0.addEventListener('click', function () { S.rot = 0; render(); save(); });
    if (r9) r9.addEventListener('click', function () { S.rot = 90; render(); save(); });
    var lsw = q('#agsLogoSw'); if (lsw) lsw.addEventListener('click', function () { S.logoOn = !S.logoOn; if (S.logoOn && !S.logo) S.logo = defaultLogo(); clampLogo(); render(); save(); });
    ['#agsLw', '#agsLh'].forEach(function (id) { var i = q(id); if (!i) return; i.addEventListener('change', function () { if (!S.logo) S.logo = defaultLogo(); S.logo.w = Number(q('#agsLw').value) || 6; S.logo.h = Number(q('#agsLh').value) || 3; clampLogo(); render(); save(); }); });
    /* CENTER LOGO ON PAD (8 Oct 2026; James: "we also need a logo center button") - the helm studio's own button: the box to the pad's centre both
       ways, then held where a logo may stand (clampLogo - off the border, above the ruler when there is one) */
    var lc = q('#agsLogoCenter'); if (lc) lc.addEventListener('click', function () { var G = geom(); if (!S.logo || !G) return; S.logo.x = G.W / 2; S.logo.y = G.H / 2; clampLogo(); render(); save(); });
    var ub = q('#agsLogoUpBtn'), fi = q('#agsLogoFile');
    if (ub && fi) {
      ub.addEventListener('click', function () { fi.click(); });
      fi.addEventListener('change', function () {
        logoFile = fi.files && fi.files[0] ? fi.files[0] : null; logoImg = null;
        if (ub) ub.textContent = logoFile ? ('Logo: ' + logoFile.name + ' (change)') : 'Upload your logo image';
        if (logoFile && /^image[/]/.test(logoFile.type || '')) { var rd = new FileReader(); rd.onload = function (e) { logoImg = e.target.result; render(); }; rd.readAsDataURL(logoFile); }
        else render();
      });
    }
    var rsw = q('#agsRulSw'); if (rsw) rsw.addEventListener('click', function () { if (!rulerFits()) return; S.ruler = !S.ruler; if (S.logo) clampLogo(); render(); save(); });
    var bb = q('#agsBuildBtn'), bd = q('#agsBuild'); if (bb && bd) bb.addEventListener('click', function () { bd.style.display = bd.style.display === 'none' ? '' : 'none'; });
    var rs = q('#agsReset'); if (rs) rs.addEventListener('click', function () { var k = S.key; S = JSON.parse(JSON.stringify(DEF)); S.key = k; logoFile = null; logoImg = null; buildColors(); buildTiles(); render(); save(); });
    var atc = q('#agsAtc'); if (atc) atc.addEventListener('click', addToCart);
    var svg = q('#agsSvg'); if (svg) { svg.addEventListener('pointerdown', onDown); svg.addEventListener('pointermove', onMove); svg.addEventListener('pointerup', onUp); svg.addEventListener('pointercancel', onUp); }
  }
  /* 7 Oct 2026 - James: "We need all the coolers to be on the studio when we go live and archive the current active listings". Every old
     cooler page sends its customer here as ?cooler=<the variant's SKU>: the studio opens on that lid (a SKU is the lid's key; the one alias
     as the lid list's builder has it). Anything unknown is ignored - the page opens as it always did. */
  var SKU_ALIAS = {yeti_load_out_lid_nonvented: 'yeti_load_out_lid'};
  var deepFrom = null;
  function lidKey(v) {   /* a variant's SKU (or a lid key) -> the lid's key: lower case, the one alias - the deep link and the doors both ask here */
    v = String(v == null ? '' : v).trim().toLowerCase();
    return SKU_ALIAS.hasOwnProperty(v) ? SKU_ALIAS[v] : v;
  }
  function deepLid() {
    var v = null; try { v = new URLSearchParams(location.search).get('cooler'); } catch (e) {}
    if (!v) return null;
    v = lidKey(v);
    return (LIDS && LIDS.lids.hasOwnProperty(v)) ? v : null;
  }
  /* 8 Oct 2026 - THE BRAND PAGES ARE DOORS (James: "build the brand pages as studio doors i want the most exposure"): a door's button
     (data-ag-cooler-open-on="<the variant's SKU>") opens the studio on that lid. A click before the lid list has loaded is kept and done
     once it has. An unknown SKU opens the studio as it stands. */
  var pendingOn = null;
  function openOn(v) {
    var k = lidKey(v);
    if (!LIDS) { pendingOn = k; return; }
    if (LIDS.lids.hasOwnProperty(k)) { S.key = k; buildBrands(); pickLid(k); buildTiles(); }
    open();
  }
  function boot() {
    toBody();
    injectTexCSS();
    restore();
    wire();
    buildColors();
    if (!CFG.lids) { if (window.console) console.error('[AG cooler] no lid list'); return; }
    fetch(CFG.lids, {credentials: 'same-origin'}).then(function (r) { return r.json(); }).then(function (j) {
      LIDS = j;
      deepFrom = deepLid();
      if (deepFrom) S.key = deepFrom;
      var startKey = lidKey(CFG.start);
      if (!S.key || !LIDS.lids[S.key]) { S.key = null; START_BRAND = (startKey && LIDS.lids[startKey]) ? LIDS.lids[startKey].b : LIDS.brands[0][0]; }
      var onKey = pendingOn;
      if (onKey && LIDS.lids.hasOwnProperty(onKey)) S.key = onKey;
      buildBrands();
      if (S.key) pickLid(S.key);
      buildTiles();
      if (deepFrom || onKey !== null || /(^|#)studio$/.test(location.hash || '')) open();
      pendingOn = null;
    }).catch(function (e) { if (window.console) console.error('[AG cooler] lid list:', e); var n = q('#agcNote'); if (n) n.textContent = 'The studio could not load - please refresh, or call 203-580-8080.'; });
    window.AGCooler = {state: function () { return S; }, lids: function () { return LIDS; }, deep: function () { return deepFrom; }, geom: geom, price: price, props: function () { return props('cfg-test'); }, design: design, open: open, render: render, pick: pickLid, vkey: function () { return vkey(); }};
    /* the page's hero button and the studio deep link (aquagrip-studio-hero, aquagrip-studio-deeplink) open the studio through this */
    window.AGStudio = {open: open, close: close, openOn: openOn};
    window.addEventListener('hashchange', function () { if (/(^|#)studio$/.test(location.hash || '')) open(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
